import client from './client';

export default (function HometownGroupService() {
  let service;

  if (!service) {
    service = client.service('hometownGroups');
  }

  return service;
}());
